import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export interface FooterContent {
  id: string;
  logo_url: string | null;
  favicon_url: string | null;
  copyright_text: string;
  description: string;
  facebook_enabled: boolean;
  facebook_url: string | null;
  instagram_enabled: boolean;
  instagram_url: string | null;
  twitter_enabled: boolean;
  twitter_url: string | null;
  linkedin_enabled: boolean;
  linkedin_url: string | null;
  youtube_enabled: boolean;
  youtube_url: string | null;
  privacy_policy_enabled: boolean;
  privacy_policy_url: string | null;
  terms_enabled: boolean;
  terms_url: string | null;
  cookie_policy_enabled: boolean;
  cookie_policy_url: string | null;
  email: string | null;
  phone: string | null;
  address: string | null;
  organization_name: string;
  tax_code: string | null;
  updated_at: string;
}

export const useFooterContent = () => {
  return useQuery({
    queryKey: ["footer-content"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("footer_content")
        .select("*")
        .maybeSingle();

      if (error) throw error;
      return data as FooterContent | null;
    },
  });
};

export const useUpdateFooterContent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (updates: Partial<FooterContent>) => {
      const { data: existing } = await supabase
        .from("footer_content")
        .select("id")
        .maybeSingle();

      if (existing) {
        const { data, error } = await supabase
          .from("footer_content")
          .update(updates)
          .eq("id", existing.id)
          .select()
          .single();

        if (error) throw error;
        return data;
      } else {
        const { data, error } = await supabase
          .from("footer_content")
          .insert(updates)
          .select()
          .single();

        if (error) throw error;
        return data;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["footer-content"] });
      toast.success("Contenuto footer aggiornato");
    },
    onError: (error) => {
      toast.error("Errore nell'aggiornamento: " + error.message);
    },
  });
};
